import { render, staticRenderFns } from "./UsuariosVinculado.vue?vue&type=template&id=1fc4c81a"
import script from "./UsuariosVinculado.vue?vue&type=script&lang=js"
export * from "./UsuariosVinculado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports